export const TEEN_PRELOAD_CARD_DATA_EVENTS = {
  VIEW_ONBOARDING_KID_NAME: 'view_onboarding_kid_name',
  SELECT_ONBOARDING_KID_NAME_CONTINUE: 'select_onboarding_kid_name_continue',
  SELECT_ONBOARDING_CHANGE_CARD_THEME: 'select_onboarding_change_card_theme',
} as const;
